import qs from 'qs';

// parse query params
export function parseQueryParams(location) {
    if (location && location.search) {
        const tmp = qs.parse(location.search.slice(1)); 
        const query = {};
        
        Object.keys(tmp).forEach(key => {
            if (tmp[key] !== undefined) query[key] = tmp[key];
        });

        return query;
    }

    return {}
}

// stringify query params
export function stringifyQueryParams(query) {
    if (typeof query === 'object') {
        return `?${qs.stringify(query)}`;
    }

    return '?';
}

export const LICENSE_URL = {
    about_us: 'https://sellonboard.com/about-us/',
    contact_us: 'https://sellonboard.com/contact-us/',
    pricing: 'https://sellonboard.com/pricing/',
    privacy_policy: 'https://sellonboard.com/privacy-policy/',
    term_of_user: 'https://sellonboard.com/term-of-use/',
    refund_cancellation_policy: 'https://sellonboard.com/refund-cancellation-policy/',
    merchant_agreement: 'https://sellonboard.com/repository/terms-dsign.pdf',
};
